"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Languages = _interopRequireDefault(require("../constants/Languages"));

var _LanguageUtil = _interopRequireDefault(require("../util/LanguageUtil"));

var _Urls = require("../util/Urls");

var LanguageSwitchPopup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(LanguageSwitchPopup, _React$Component);

  function LanguageSwitchPopup() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, LanguageSwitchPopup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(LanguageSwitchPopup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderCheck = function (language) {
      return _LanguageUtil.default.getUserLanguage() === language ? _react.default.createElement("span", {
        className: "icon icon-check"
      }) : undefined;
    };

    _this.renderLanguages = function () {
      return Object.keys(_Languages.default).map(function (languageKey, index) {
        var language = _Languages.default[languageKey];
        return _react.default.createElement("li", {
          key: index
        }, _react.default.createElement("a", {
          className: "language-switcher-link",
          href: (0, _Urls.getLocalizedUrl)(languageKey)
        }, _this.renderCheck(languageKey), language));
      });
    };

    return _this;
  }

  (0, _createClass2.default)(LanguageSwitchPopup, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var ulClassNames = (0, _classnames.default)({
        open: props.isOpen
      });
      return _react.default.createElement("ul", {
        className: ulClassNames
      }, this.renderLanguages());
    }
  }]);
  return LanguageSwitchPopup;
}(_react.default.Component);

LanguageSwitchPopup.propTypes = {
  isOpen: _propTypes.default.bool
};
var _default = LanguageSwitchPopup;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/LanguageSwitcherPopup.js
// module id = 255
// module chunks = 0